import type { ReactNode } from "react";

interface MarketingContainerProps {
  children: ReactNode;
  className?: string;
}

export function MarketingContainer({
  children,
  className = "",
}: MarketingContainerProps) {
  return (
    <div
      className={[
        "mx-auto w-full max-w-7xl px-5 sm:px-8 lg:px-10",
        className,
      ].join(" ")}
    >
      {children}
    </div>
  );
}
